import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AccountService } from '../services/account.service';
import { ConfigurationService } from '../services/configuration.service';

@Injectable({
    providedIn: 'root',
})
export class ReportHttpService {
    constructor(private configurations: ConfigurationService, private http: HttpClient, private accountService: AccountService) {}

    getEndOfDayReport(date: any): Observable<any> {
        return this.http.get<any>(`${this.configurations.baseUrl}/api/report/getEndOfDayReport`, {
            params: { date: date, branchId: this.accountService.currentUser.branchId },
        });
    }
}
